var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticStyle:{"display":"inline-flex","flex-direction":"column","text-align":"center"}},[_vm._t("default"),_c('p',{staticClass:"smaller-text",staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.$t(_vm.name)))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }